module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 12,
      "lg": 12
    }
  }, [(_vm.$store.getters.login_type != 'distributor') ? _c('shop-select', {
    attrs: {
      "wxshops": ""
    },
    on: {
      "update": _vm.shopHandle
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 10,
      "lg": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号/订单号",
      "size": "mini"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.numberSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择订单类型",
      "size": "mini"
    },
    on: {
      "change": _vm.TypeHandle
    },
    model: {
      value: (_vm.order_type),
      callback: function($$v) {
        _vm.order_type = $$v
      },
      expression: "order_type"
    }
  }, [_vm._l((_vm.orderType), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.type
      }
    })
  }), _vm._v(" "), _c('el-option', {
    key: 2,
    attrs: {
      "label": "拼团订单",
      "value": "groups"
    }
  })], 2)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.querySearch,
      "placeholder": "请输入来源",
      "size": "mini"
    },
    on: {
      "select": _vm.sourceSearch
    },
    model: {
      value: (_vm.source_name),
      callback: function($$v) {
        _vm.source_name = $$v
      },
      expression: "source_name"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 8,
      "lg": 6
    }
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "订单下载",
      "visible": _vm.downloadView,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.downloadView = $event
      }
    }
  }, [(_vm.downloadUrl) ? [_c('a', {
    attrs: {
      "href": _vm.downloadUrl,
      "download": ""
    }
  }, [_vm._v(_vm._s(_vm.downloadName))])] : _vm._e()], 2), _vm._v(" "), _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "全部",
      "name": "all"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "已完成",
      "name": "done"
    }
  }), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "未支付",
      "name": "notpay"
    }
  }), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 200
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "width": "160",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2176513052)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "width": "160",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "title",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "total_fee",
      "label": "金额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n            " + _vm._s(scope.row.fee_symbol) + _vm._s(scope.row.total_fee / 100) + "\n          ")]
      }
    }], null, false, 4222832577)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobile",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_type",
      "label": "类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [('groups' == scope.row.order_class) ? _c('span', [_c('span', [_vm._v("\n                拼团订单\n              ")])]) : _c('span', _vm._l((_vm.orderType), function(item, index) {
          return (item.type == scope.row.order_type) ? _c('span', {
            key: index
          }, [_vm._v("\n                " + _vm._s(item.name) + "\n              ")]) : _vm._e()
        }), 0)]
      }
    }], null, false, 2120315680)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_status",
      "label": "订单状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.order_status == 'DONE' || scope.row.order_status == 'PAYED') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("已完成")]) : (scope.row.order_status == 'NOTPAY') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("未支付")]) : (scope.row.order_status == 'CLOSED') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已取消")]) : (scope.row.order_status == 'REFUND_PROCESS') ? _c('el-tag', {
          attrs: {
            "type": "warning",
            "size": "mini"
          }
        }, [_vm._v("退款处理中")]) : (scope.row.order_status == 'REFUND_SUCCESS') ? _c('el-tag', {
          attrs: {
            "type": "info",
            "size": "mini"
          }
        }, [_vm._v("退款成功")]) : (scope.row.order_status == 'REFUND_FAIL') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("退款失败")]) : _vm._e()]
      }
    }], null, false, 3220902823)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "source_name",
      "label": "来源"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "operator_desc",
      "label": "代客下单操作员"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('detail'),
              query: {
                orderId: scope.row.order_id,
                resource: '/mall/trade/service'
              }
            }
          }
        }, [_vm._v("详情")])]
      }
    }], null, false, 2481100495)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-537147c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-537147c2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/trade/order/list.vue
// module id = 2716
// module chunks = 0